export const globalMenuWidthSmall = 72;
export const globalMenuWidthFull = 240;
export const globalMenuHideDelayMillis = 250;
